import { render } from "./MenuItem.vue?vue&type=template&id=b19f93e0&scoped=true&ts=true"
import script from "./MenuItem.vue?vue&type=script&lang=ts"
export * from "./MenuItem.vue?vue&type=script&lang=ts"

import "./MenuItem.vue?vue&type=style&index=0&id=b19f93e0&lang=scss&scoped=true"

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b19f93e0"]])

export default __exports__